import React, { useState } from 'react'
import { Modal, Button, message, Select, Input, Spin, Popconfirm } from 'antd'
import { v4 as uuidV4 } from 'uuid'
import { uploadImageSku } from "../../../services/api/apiSku"
import { DeleteOutlined, EyeTwoTone, UploadOutlined, LoadingOutlined } from '@ant-design/icons'

const ModalBrandDescriptionPackaged = (props) => {
    const {
        skuID,
        getDetailSku,
        brandOptions,
        actionUpdate,
        isOpen = false,
        onOpenDescribeBrand,
        brandsDescriptionPackaged,
        onChangeBrandsDescriptionPackaged,
    } = props
    const inputFileRefBrand = {}

    const [loading, setLoading] = useState(false)
    const [isOpenPreview, setIsOpenPreview] = useState(false)
    const [imageSelect, setImageSelect] = useState(false)
    const [errors, setErrors] = useState({})
    const [isChange, setIsChange] = useState(false)

    const handleUpdateDescriptionBrand = async () => {
        try {
            if (!_validate()) return

            await actionUpdate()
            message.success("Cập nhật thành công.")
            handleCancel()
        } catch (error) {
            message.error(error.message)
        }
    }

    const _validate = () => {
        const newErrors = {}
        brandsDescriptionPackaged.forEach(item => {
            const itemErrors = {}

            if (!item.brand || item.brand.trim() === "") {
                itemErrors.brand = "Brand là bắt buộc"
            }

            if (!item.description || item.description.trim().length < 20) {
                itemErrors.description = "Mô tả phải tối thiểu 20 ký tự"
            }

            if (Object.keys(itemErrors).length > 0) {
                newErrors[item.idx] = itemErrors
            }
        })

        setErrors(newErrors)

        return Object.keys(newErrors).length === 0
    }

    const handleCancel = () => {
        onOpenDescribeBrand(false)
        getDetailSku()
        setErrors({})
        setIsChange(false)
    }

    const _handleAddImageBrand = (id) => {
        inputFileRefBrand[id].click()
        setIsChange(true)
    }

    const _handleRemoveImageBrand = (id, imageUrl) => {
        const newData = brandsDescriptionPackaged.map(i => {
            const { images = [] } = Object.assign({}, i)
            const newImages = images.filter(o => o !== imageUrl)
            if (i.idx === id) {
                return {
                    ...i,
                    isChange: true,
                    images: newImages
                }
            }
            return i
        })

        onChangeBrandsDescriptionPackaged(newData)
        setIsChange(true)
    }

    const _handleFileChangeBrand = async (event, brandId) => {
        setLoading(true)

        const file = event.target.files[0]
        const validImageTypes = ['image/png', 'image/jpeg', 'image/jpg']

        if (!file) return

        const maxSize = 10 * 1024 * 1024 // 10MB
        if (file && file.size > maxSize) {
            message.error('File phải nhỏ hơn 10MB.')
            setLoading(false)
            return
        }

        if (file && !validImageTypes.includes(file.type)) {
            message.error('Chỉ hỗ trợ định dạng [image/png,image/jpeg,image/jpg].')
            setLoading(false)
            return
        }

        const newData = brandsDescriptionPackaged.map(item => {
            if (item.idx === brandId) {
                return {
                    ...item,
                    isLoading: true,
                }
            }
            return { ...item, isLoading: false }
        })

        onChangeBrandsDescriptionPackaged(newData)

        try {
            const formData = new FormData()
            file && formData.append('file', file)
            formData.append('objectId', skuID)
            formData.append('objectName', 'Sku')

            const { data } = await uploadImageSku(formData)
            const { data: res, success, message: mess } = Object.assign({}, data)
            if (!success) return message.error(mess)

            const newData = brandsDescriptionPackaged.map(item => {
                const { images = [] } = Object.assign({}, item)
                if (item.idx === brandId) {
                    return {
                        ...item,
                        isChange: true,
                        isLoading: false,
                        images: [
                            ...images,
                            res
                        ]
                    }
                }
                return item
            })
            onChangeBrandsDescriptionPackaged(newData)

            if (inputFileRefBrand[brandId]) inputFileRefBrand[brandId].value = null
            setIsChange(true)
        } catch (error) {
            message.error(error.message)
        } finally {
            setLoading(false)
        }
    }

    const _handleChange = (id, field, value) => {
        const newData = brandsDescriptionPackaged.map(i => {
            if (i.idx === id) {
                return {
                    ...i,
                    [field]: value
                }
            }

            return i
        })

        setErrors(prev => {
            const newErrors = { ...prev }
            if (newErrors[id]) {
                delete newErrors[id][field]

                if (Object.keys(newErrors[id]).length === 0) {
                    delete newErrors[id]
                }
            }
            return newErrors
        })

        onChangeBrandsDescriptionPackaged(newData)
        setIsChange(true)
    }

    const _handleAdd = () => {
        const newData = [
            ...brandsDescriptionPackaged,
            {
                brand: '',
                description: '',
                images: [],
                isChange: false,
                isLoading: false,
                idx: uuidV4(),
            }
        ]
        onChangeBrandsDescriptionPackaged(newData)
        setIsChange(true)
    }

    const _handleRemove = id => {
        setErrors(prev => {
            const newErrors = { ...prev }
            if (newErrors[id]) {
                delete newErrors[id]
            }
            return newErrors
        })
        const newData = brandsDescriptionPackaged.filter(i => i.idx !== id)
        onChangeBrandsDescriptionPackaged(newData)
        setIsChange(true)
    }

    return (
        <Modal
            title={<span className='font-weight-bold'>Mô tả thông tin QCHT</span>}
            visible={isOpen}
            closable={false}
            footer={[
                <div className='d-flex align-items-center justify-content-between'>
                    <Button style={{ background: '#777777', color: "#ffffff" }} onClick={handleCancel}>
                        Hủy
                    </Button>
                    <Button
                        style={{ background: (!!Object.keys(errors).length || !isChange) ? '#82868999' : '#3f97f6', color: "#ffffff" }}
                        onClick={handleUpdateDescriptionBrand}
                        disabled={!isChange || loading || !!Object.keys(errors).length}
                        loading={loading}
                    >
                        Cập nhật
                    </Button>
                </div>
            ]}
            width={"1400px"}
            style={{ maxWidth: '90%' }}
            className="modalDescribeBrand"
            // zIndex={"9999"}
        >
            <div style={{ maxHeight: '670px', overflow: 'auto' }}>
                <table>
                    <thead>
                        <tr>
                            <th className='text-center brand'>Brand</th>
                            <th className='text-center description'>Mô tả thông tin QCHT</th>
                            <th className='text-center image'>Hình ảnh</th>
                            <th className='text-center action'>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            brandsDescriptionPackaged.map((item, index) => {
                                const { idx, isLoading = false, images, brand, description} = item
                                return (
                                    <tr key={idx}>
                                        <td className='brand'>
                                            <Select
                                                value={brand || []}
                                                showSearch
                                                placeholder="--Select Brand"
                                                onChange={value => _handleChange(idx, 'brand', value)}
                                                filterOption={(input, option) => {
                                                    return option.children.toLowerCase().includes(input.toLowerCase())
                                                }}
                                                style={{ width: '100%' }}
                                            >
                                                {brandOptions.map((option, index) => (
                                                    <Select.Option
                                                        key={option.value}
                                                        value={option.value}
                                                        disabled={brandsDescriptionPackaged.some((row) => row.brand === option.value && row.idx !== idx)}
                                                    >{option.name}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                            
                                            {
                                                !!errors[idx] && !!errors[idx].brand &&
                                                <div className='text-danger mt-1'>{errors[idx].brand}</div>
                                            }
                                        </td>
                                        <td className='description'>
                                            <Input.TextArea
                                                placeholder="Nhập mô tả thông tin QCHT tối thiểu 20 ký tự"
                                                value={description}
                                                onChange={e => _handleChange(idx, 'description', e.target.value)}
                                                rows={4}
                                            />
                                            {
                                                !!errors[idx] && !!errors[idx].description &&
                                                <div className='text-danger mt-1'>{errors[idx].description}</div>
                                            }
                                        </td>
                                        <td className='image'>
                                            <div className={`d-flex align-items-center justify-content-center`}>
                                                {
                                                    !!images.length &&
                                                    <div className="d-flex align-items-center">
                                                        {
                                                            images.map((item, index) => (
                                                                <div className={`image-item-upload position-relative ${index < 2 && 'mr-3'}`} key={item}>
                                                                    <img
                                                                        src={item}
                                                                        alt="preview"
                                                                        style={{ maxWidth: 'none', maxHeight: 'none' }}
                                                                        loading='lazy'
                                                                    />
                                                                    {!isLoading && <Popconfirm
                                                                        placement="topRight"
                                                                        title="Bạn chắc chắn muốn xóa ảnh này?"
                                                                        onConfirm={() => _handleRemoveImageBrand(idx, item)}
                                                                        okText="Xóa"
                                                                        cancelText="Không"
                                                                    >
                                                                        <DeleteOutlined className='delete-image-item' />
                                                                    </Popconfirm>}
                                                                    <EyeTwoTone
                                                                        className='eyes-image-item'
                                                                        onClick={() => {
                                                                            setIsOpenPreview(true)
                                                                            setImageSelect(item)
                                                                        }}
                                                                    />
                                                                    <Modal
                                                                        visible={isOpenPreview && item === imageSelect}
                                                                        title={'Preview image'}
                                                                        onCancel={() => {
                                                                            setIsOpenPreview(false)
                                                                            setImageSelect('')
                                                                        }}
                                                                        closable={false}
                                                                        footer={false}
                                                                    >
                                                                        <img
                                                                            src={item}
                                                                            alt="preview"
                                                                            width={"100%"}
                                                                        />
                                                                    </Modal>
                                                                </div>
                                                            ))
                                                        }
                                                    </div>
                                                }
                                                {isLoading ?
                                                    <Spin indicator={
                                                        <LoadingOutlined
                                                            style={{
                                                                fontSize: 24,
                                                            }}
                                                            spin
                                                        />} /> :
                                                    (images.length < 3 && <UploadOutlined style={{ fontSize: 18, cursor: 'pointer' }} onClick={() => _handleAddImageBrand(idx)} />)
                                                }
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    ref={el => (inputFileRefBrand[idx] = el)}
                                                    hidden
                                                    onChange={(e) => _handleFileChangeBrand(e, idx)}
                                                />
                                            </div>
                                        </td>
                                        <td className='action'>
                                            {
                                                brandsDescriptionPackaged.length > 1 &&
                                                <i
                                                    className="icon-bin text-danger cursor-pointer"
                                                    onClick={() => _handleRemove(idx)}
                                                />
                                            }
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td className='action'>
                                <i
                                    className="icon-plus-circle2 text-success cursor-pointer"
                                    onClick={_handleAdd}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Modal>
    )
}

export default ModalBrandDescriptionPackaged